<template>
    <span class="release-type"
        v-if="props.trackCount"
    >
        <template v-if="props.trackCount >= 7">
            {{ t('pluralization.releases.album', 1) }}
        </template>
        <template v-else-if="props.trackCount >= 4 && props.trackCount < 7">
            {{ t('pluralization.releases.ep', 1) }}
        </template>
        <template v-else>
            {{ t('pluralization.releases.single', 1) }}
        </template>
    </span>
</template>

<script setup>
    import Button from '🔗/components/ui/Button.vue';

    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps({
        trackCount: { type: [Number, null], default: null }
    });
</script>

<style lang="scss" scoped>
    .release-type {
        
    }
</style>
